import React, { useContext } from 'react'
import { ContentFooter } from '../../layout/Content'
import RecordNavigator from '../../layout/RecordNavigator'
import CustomersAccountsListFooterStyle from './css/CustomersAccountsListFooterStyle'
import { customersAccountsListControllerContext } from './CustomersAccountsListController'

function CustomersAccountsListFooter() {
  const customersAccountsListController = useContext(customersAccountsListControllerContext)
  const { getTotalCustomersAccountsRecord, totalPage } = customersAccountsListController

  const [recordPerPage, setRecordPerPage] = customersAccountsListController.recordPerPage
  const [recPP, setRecPP] = customersAccountsListController.recPP
  const [page, setPage] = customersAccountsListController.page

  const recordNavigatorProps = {
    recPP: [recPP, setRecPP],
    page: [page, setPage],
    recordPerPage: [recordPerPage, setRecordPerPage],
    getTotalRecords: getTotalCustomersAccountsRecord,
    totalPage,
  }

  return (
    <ContentFooter>
      <div id="customer-accounts-list-footer-container">
        <RecordNavigator { ... recordNavigatorProps } />
      </div>
      <CustomersAccountsListFooterStyle />
    </ContentFooter>
  )
}

export default React.memo(CustomersAccountsListFooter)
